export { default } from "./Categorias";
